module.exports = __webpack_public_path__ + "img/4.f9f2e1e0.jpg";